import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: 'not-found.view.html',
  styleUrls: ['./not-found.view.scss'],
  standalone: false,
})
export class NotFoundViewComponent {}
// TODO: Wrap this into the default view.
